<template>
    <li class="sport__block finder__card" :class="cardClass">
        <a :href="sport.link" class="finder__card-link">
            
            <div class="finder__card-content">
                <h3 class="step--3" v-html="sport.title"></h3>

                <p
                    v-if="footnote && eligible"
                    class="finder__footnote"
                    v-html="footnote"
                ></p>

                <p class="finder__eligibility" :class="eligibilityClass">
                    <span
                        v-if="eligible"
                        class="finder__eligibility-icon"
                        aria-hidden="true"
                        v-html="icoCheck"
                    ></span>
                        {{ eligibilityLabel }}
                </p>

                <span class="screen-reader-text">{{ screenReaderSuffix }}</span>
            </div>
            <span class="finder__card-icon" v-html="sport.icon"></span>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        sport: {
            type: Object,
            required: true,
        },
        eligible: {
            type: Boolean,
            default: true,
        },
        facetTitle: {
            type: String,
            default: '',
        },
        footnote: {
            type: String,
            default: '',
        },
        forLabel: {
            type: String,
            default: '',
        },
        eligibleLabel: {
            type: String,
            default: '',
        },
        notEligibleLabel: {
            type: String,
            default: '',
        },
        icoCheck: {
            type: String,
            default: '',
        },
    },
    computed: {
        cardClass() {
            return this.eligible ? 'finder__card--eligible' : 'finder__card--not-eligible';
        },
        eligibilityClass() {
            return this.eligible ? '' : 'finder__eligibility--not';
        },
        eligibilityLabel() {
            return this.eligible ? this.eligibleLabel : this.notEligibleLabel;
        },
        screenReaderSuffix() {
            return `${ this.sport.title } ${ this.forLabel } ${ this.facetTitle }`;
        },
    },
};
</script>
